import { createRef } from "react";
import LoginPage from "../pages/Login";
import LogoutPage from "../pages/Logout";

// feature routes
export const routes = [
  {
    path: "/login",
    element: <LoginPage />,
    handle: {
      name: "Login",
      nodeRef: createRef(),
    },
  },
  {
    path: "/logout",
    element: <LogoutPage />,
    handle: {
      name: "Logout",
      nodeRef: createRef(),
    },
  },
];
